<template>
  <div class="flex flex-col">
    <span class="text-sm border-b text-gray-400">Students Pending Route Pulling</span>
    <div class="p-2 rounded-md bg-gray-100 shadow-sm">
      <div class="p-2 rounded-md bg-gray-50">
        <div class="grid grid-cols-3 gap-2 pb-2">
          <TextField
            v-model="formValues.filterStudents">
            Student Field Filter
          </TextField>
          <VSelectionField class="col-span-2"
            :multiple="true"
            v-model="formValues.selectedPartitions"
            :options="partitionOptions">
            Partitions
          </VSelectionField>
        </div>
        <div class="flex relative justify-center items-center mt-4">
          <PaginationButton
            :pages="pages"
            :initPage="currentPage"
            @toPage="onToPage"
          />
          <div class="absolute right-0 text-gray-400 mt-1 text-sm">
            Total Entries: {{ totalStudentsPendingRoutePull }}
          </div>
        </div>
        <Spinner
          v-if="displayLoadingStudentsPendingRoutePullSpinner"
          message="Loading Students Pending Route Pull"
          :size="16"
        />
        <DataTable
          ref="studentsTable"
          :tableHeads="studentsTableHeads"
          :dataKeyList="studentsTableKeys"
          :dataItems="studentsPendingChanges"
          uniqueKeyValue="id"
          @toggle="onToggleStudentPending"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from './DataTable.vue'

import Spinner from '../Spinner.vue'
import PaginationButton from '../PaginationButton.vue'

import VSelectionField from '../formComponents/VSelectionField.vue'
import TextField from '../formComponents/TextField.vue'

import user from '../../services/user/user'
import partitions from '../../services/partitions.js'

export default {
  components: {
    DataTable,
    Spinner,
    PaginationButton,
    VSelectionField,
    TextField,
  },
  data() {
    return {
      formValues: {
        filterStudents: undefined,
        selectedPartitions: []
      },

      studentsTableHeads: ['Internal ID', 'First Name', 'Last Name', 'Type'],
      studentsTableKeys: ['internalId', 'firstName', 'lastName', 'type'],
      studentsPendingChanges: [],
      totalStudentsPendingRoutePull: 0,

      pages: undefined,
      currentPage: 1,

      partitionOptions: [],

      displayLoadingStudentsPendingRoutePullSpinner: false,
    }
  },
  methods: {
    callOnceWithDelay(callback, delayTime) {
      if (this.formValuesChangeApiCallDelay) {
        clearTimeout(this.formValuesChangeApiCallDelay)
      }
      this.formValuesChangeApiCallDelay = setTimeout(() => {
        callback()
      }, delayTime)
    },
    onToggleStudentPending() {
      //
    },
    loadStudentsPendingRoutePull() {
      console.log('loading data from server')
    },
    onToPage(pageNumber) {
      this.currentPage = pageNumber
      this.loadStudentsPendingRoutePull()
    },
    onClickStudent(index) {
      console.log(this.studentsPendingChanges[index])
    }
  },
  async mounted() {
    await user.ready()
    await partitions.getPartitionFromServer()
    let response = await partitions.getPartitionFromServer()
    this.partitionOptions = response.data.map((partitionData) => {
      return {
        label: partitionData.description,
        value: partitionData.id,
      }
    })
  },
  watch: {
    formValues: {
      deep: true,
      handler() {
        this.callOnceWithDelay(() => this.loadStudentsPendingRoutePull(), 1000)
      },
    }
  }
}
</script>
